import { createEvent, createStore } from 'effector/compat'
import { ICatalogGoodBase } from '@entities/goods/contract'
import { useStoreMap } from 'effector-react/compat'
import { NextContext } from 'src/shared/contract/type'

export interface IInitGroupGoods {
    groupId: number
    ctx?: NextContext
}

export const resetGood = createEvent()

export const $goods = createStore<ICatalogGoodBase[]>([] as ICatalogGoodBase[]).reset(resetGood)

export const useGoodsCount = () => useStoreMap($goods, (state) => state.length)
